import React, { useRef } from "react";
import PhotoCapture from "@/components/PhotoCapture";
import { fileUrl } from "@/lib/api";
import { X } from "lucide-react";

// Unlimited photos. Controlled via `paths` + `onChange`.
export default function MultiPhotoCapture({ category = "uploads", paths = [], onChange, label = "Foto", facingMode = "user", testIdPrefix = "multi-photo" }) {
  const pathsRef = useRef(paths);
  pathsRef.current = paths;
  const add = (p) => {
    const next = [...(pathsRef.current || []), p];
    pathsRef.current = next; // update immediately so a burst of uploads accumulates
    onChange(next);
  };
  const remove = (i) => onChange(paths.filter((_, x) => x !== i));

  return (
    <div className="space-y-3">
      {paths.length > 0 && (
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid={`${testIdPrefix}-grid`}>
          {paths.map((p, i) => (
            <div key={i} className="relative group">
              <a href={fileUrl(p)} target="_blank" rel="noopener noreferrer">
                <img src={fileUrl(p)} alt={`foto ${i + 1}`} className="w-full h-24 object-cover rounded-xl border-2 border-teal-100" data-testid={`${testIdPrefix}-thumb-${i}`} />
              </a>
              <button type="button" onClick={() => remove(i)} className="absolute -top-2 -right-2 bg-rose-500 text-white rounded-full p-1 shadow" data-testid={`${testIdPrefix}-remove-${i}`} aria-label="Hapus foto">
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
      <PhotoCapture
        multiple
        category={category}
        facingMode={facingMode}
        label={paths.length ? "Tambah Foto Lagi" : label}
        testIdPrefix={testIdPrefix}
        onUploaded={add}
      />
      {paths.length > 0 && <p className="text-xs text-slate-500" data-testid={`${testIdPrefix}-count`}>{paths.length} foto ditambahkan — bisa tambah sebanyak yang kamu mau.</p>}
    </div>
  );
}
